var M = Object.defineProperty;
var W = (e, n, l) => n in e ? M(e, n, { enumerable: !0, configurable: !0, writable: !0, value: l }) : e[n] = l;
var A = (e, n, l) => W(e, typeof n != "symbol" ? n + "" : n, l);
import { defineComponent as G, useTemplateRef as O, computed as a, ref as J, reactive as K, getCurrentInstance as Q, watch as w, onMounted as U, nextTick as q, resolveComponent as X, resolveDirective as Y, createBlock as Z, openBlock as o, normalizeClass as C, withCtx as V, createElementBlock as r, createCommentVNode as s, withDirectives as x, renderSlot as p, toDisplayString as k, createElementVNode as _, mergeProps as D, toHandlers as F } from "vue";
import { u as ee } from "./events-BZdEdnD6.js";
import { a as te } from "./autoFocus-CVmVp5SB.js";
import { h as ne } from "./hide-label-cYI1fuDW.js";
import ae from "./ErrorTooltip-gIdejoEn.js";
import { d as oe } from "./debounce-CG9EzSwd.js";
import { _ as le } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const ie = G({
  inheritAttrs: !1,
  components: { ErrorTooltip: ae },
  directives: { hideLabelDirective: ne },
  slots: Object,
  props: {
    id: String,
    disabled: Boolean,
    /** force focused */
    focused: Boolean,
    modelValue: [String, Number],
    value: [String, Number],
    // modelModifiers: Object as PropType<{ lazyoff?: true }>,
    multiline: { type: Boolean, default: () => !1 },
    /** placeholder + label */
    placeholder: String,
    /** default value added to placeholder */
    default: [String, Number],
    formatter: Object,
    validation: Object,
    validationSilentError: { type: Boolean, default: () => !1 },
    errors: Array,
    errorPosition: String,
    inputClass: [String, Object],
    end: String,
    endClass: String,
    start: String,
    startClass: String,
    debounce: { type: Number, default: () => 300 },
    // just to detect if @input listener is set
    onInput: { type: Function, default: () => {
    } }
  },
  emits: ["update:model-value", "change", "input"],
  setup(e, { emit: n, attrs: l, slots: d }) {
    const v = O("input"), h = O("textarealength"), g = a(
      () => e.validation && e.validation.required !== void 0 || "required" in y && y.required !== !1
    ), f = a(() => e.start || d.start || d.startButton), E = a(() => e.end || d.end || d.endButton), m = a(() => e.placeholder && e.placeholder != " " ? e.placeholder : ""), I = a(() => e.default && m.value ? `${m.value}: ${e.default}` : `${m.value || e.default || ""}`), c = a(() => e.formatter || new re()), i = J();
    let b = i.value;
    function N(t) {
      n("update:model-value", t), n("change", t);
    }
    function T(t) {
      n("input", t);
    }
    function S() {
      const t = c.value.parse(i.value), u = c.value.stringify(t);
      (t ?? "") !== (e.modelValue ?? e.value ?? "") ? (N(t), q(() => {
        i.value = u;
      })) : i.value !== u && q(() => {
        i.value = u;
      });
    }
    function j(t) {
      t != null && t !== `${i.value}` && (c.value.validators.every((H) => H(t)) ? (b = t, i.value = t, e.onInput && T(c.value.parse(t)), e.multiline && h.value && (h.value.textContent = `${(t == null ? void 0 : t.length) || 0} / ${l.maxlength}`)) : (i.value = b, v.value.value = b || ""));
    }
    const { focused: L, vOn: P } = ee({ focusOut: S }), B = a(() => e.focused || L.value), { class: R, ...y } = l, z = K({
      ...y,
      id: a(() => {
        var t;
        return e.id || "input" + ((t = Q()) == null ? void 0 : t.uid);
      }),
      value: a(() => i.value),
      required: e.validation && e.validation.required !== void 0,
      placeholder: I,
      disabled: a(() => e.disabled),
      class: a(() => [
        e.inputClass,
        f.value ? "tt-rounded-l-none" : "tt-rounded-l-lg",
        E.value ? "tt-rounded-r-none" : "tt-rounded-r-lg",
        "tt-w-full",
        "tt-p-2"
      ])
    });
    w([() => e.value, () => e.modelValue], ([t, u]) => {
      i.value = c.value.stringify(t ?? u);
    }, { immediate: !0 }), U(() => {
      "autofocus" in l && l.autofocus !== !1 && v.value && te(v.value);
    });
    let $;
    return w(() => e.debounce, (t) => {
      $ = t ? oe(S, t) : void 0;
    }, { immediate: !0 }), {
      placeholderLabel: m,
      validationRequired: g,
      focused: B,
      containerClass: a(() => [
        R,
        "tx-input",
        B.value ? "tx-input-focused" : "tx-input-no-focused",
        e.disabled ? "tx-input-disabled" : "tx-input-no-disabled"
      ]),
      inputAttrs: z,
      inputOn: {
        ...P,
        mouseout: S,
        input: (t) => {
          j(t.target.value), $ && $();
        }
      },
      haveSlotStart: f,
      haveSlotEnd: E
    };
  }
});
class re {
  constructor() {
    A(this, "validators", [() => !0]);
  }
  stringify(n) {
    return n;
  }
  parse(n) {
    return n;
  }
}
const se = {
  key: 0,
  class: "tx-input-slot-string"
}, ue = { class: "tt-w-full" }, de = ["for"], ce = {
  key: 0,
  class: "tw-input-label-wildcard"
}, ve = {
  key: 3,
  ref: "textarealength",
  class: "tt-absolute tt-bottom-1 tt-right-4 tt-text-gray-400 tt-text-sm tt-select-none"
}, fe = {
  key: 0,
  class: "tx-input-slot-string"
};
function me(e, n, l, d, v, h) {
  const g = X("ErrorTooltip"), f = Y("hide-label-directive");
  return o(), Z(g, {
    class: C(e.containerClass),
    validation: e.$props.validation,
    errors: e.$props.errors,
    validationSilentError: e.$props.validationSilentError,
    focused: e.focused,
    position: e.$props.errorPosition
  }, {
    default: V(() => [
      e.haveSlotStart ? (o(), r("span", {
        key: 0,
        class: C([e.startClass, "tx-input-slot tx-input-slot-start"]),
        tabindex: "-1"
      }, [
        p(e.$slots, "start", { focused: e.focused }),
        e.start ? (o(), r("div", se, k(e.start), 1)) : s("", !0),
        p(e.$slots, "startButton", { focused: e.focused })
      ], 2)) : s("", !0),
      x((o(), r("span", ue, [
        e.placeholderLabel || e.validationRequired ? (o(), r("label", {
          key: 0,
          for: e.inputAttrs.id,
          class: "tw-input-label"
        }, [
          _("span", null, k(e.placeholderLabel), 1),
          e.validationRequired ? (o(), r("span", ce, " ∗ ")) : s("", !0)
        ], 8, de)) : s("", !0),
        e.multiline ? (o(), r("textarea", D({
          key: 1,
          ref: "input"
        }, e.inputAttrs, F(e.inputOn, !0)), null, 16)) : (o(), r("input", D({
          key: 2,
          ref: "input"
        }, e.inputAttrs, F(e.inputOn, !0)), null, 16)),
        e.multiline && e.$attrs.maxlength ? (o(), r("div", ve, null, 512)) : s("", !0)
      ])), [
        [f, e.inputAttrs.id]
      ]),
      e.haveSlotEnd ? (o(), r("span", {
        key: 1,
        class: C([e.$props.endClass, "tx-input-slot tx-input-slot-end"]),
        tabindex: "-1"
      }, [
        p(e.$slots, "endButton", { focused: e.focused }),
        e.end ? (o(), r("div", fe, k(e.end), 1)) : s("", !0),
        p(e.$slots, "end", { focused: e.focused })
      ], 2)) : s("", !0)
    ]),
    _: 3
  }, 8, ["class", "validation", "errors", "validationSilentError", "focused", "position"]);
}
const ke = /* @__PURE__ */ le(ie, [["render", me]]);
export {
  ke as default
};
//# sourceMappingURL=Input-KouLK2QK.js.map
